import { ArrowRight, ArrowDown } from "lucide-react";

const heroImage =
  "https://images.unsplash.com/photo-1771622218492-056844b21cec?fm=jpg&q=75&w=1600&auto=format&fit=crop";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-32 lg:pt-40 pb-16 md:pb-24 border-b border-black/10"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7 fade-up">
            <div className="overline mb-6" data-testid="hero-eyebrow">
              MHorgasConsult · Hamburg · Suchen · Finden · Umsetzen
            </div>
            <h1
              className="font-display font-black tracking-tighter leading-[0.92] text-5xl sm:text-6xl md:text-7xl lg:text-[88px]"
              data-testid="hero-headline"
            >
              Der Spezialist
              <br />
              für <span className="text-[#D30000]">Ausrüstungs­-</span>
              <br />
              investitionen.
            </h1>
            <p
              className="mt-8 max-w-xl text-base md:text-lg leading-relaxed text-[#4A4A52]"
              data-testid="hero-subheadline"
            >
              Drei Säulen unter einem Dach: Begleitung von Vertriebs- und
              Führungs­mannschaften in Banken, Sparkassen und Leasing­gesellschaften —
              Pay-per-Use-Spezial­finanzierung in Kooperation mit Linxfour —
              Förder­mittel & Zuschüsse auf Erfolgs­basis als Repräsentant der
              REM Capital AG.
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
              <a href="#kontakt" className="btn-primary" data-testid="hero-cta-primary">
                Erstgespräch vereinbaren <ArrowRight size={18} />
              </a>
              <a href="#saeulen" className="btn-secondary" data-testid="hero-cta-secondary">
                Säulen entdecken
              </a>
            </div>

            <div className="mt-16 grid grid-cols-2 gap-6 max-w-md border-t border-black/10 pt-8">
              <Stat value="30" label="Jahre Vertriebsleitung" />
              <Stat value="20" label="Sparkassen begleitet" />
            </div>
          </div>

          <div className="lg:col-span-5 relative aspect-[4/5] lg:aspect-auto lg:h-[640px] overflow-hidden">
            <img
              src={heroImage}
              alt="Strukturiertes Architekturmuster als Sinnbild für klare Methodik"
              className="w-full h-full object-cover grayscale contrast-110"
              data-testid="hero-image"
            />
            <div className="absolute inset-0 bg-[#0A0A0A]/20 mix-blend-multiply" />
            <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between text-white">
              <span className="text-xs uppercase tracking-[0.25em] font-semibold">
                Struktur · Klarheit · Wirkung
              </span>
              <span className="text-xs font-mono">01 / 03</span>
            </div>
          </div>
        </div>

        <div className="mt-16 flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#4A4A52]">
          <ArrowDown size={14} />
          Weiter erkunden
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-display font-black text-3xl md:text-4xl tracking-tighter">
        {value}
      </div>
      <div className="text-xs uppercase tracking-[0.18em] text-[#4A4A52] mt-1">
        {label}
      </div>
    </div>
  );
}
